import { onContributeStart } from '@/components/Contribute'
import { AppStatus } from '@/redux'
import { Chapter, Module, Prompt } from '@/types'
import { tryOpenLesson } from '@/utils'
import { navigate } from 'gatsby'

export function Feed() {
  navigate('/' as never)
}

export function Learn() {
  navigate('/learn' as never)
}

export function Collection(id: Module['id']) {
  navigate(`/learn/chapter/${id}` as never)
}

export function Lesson(id: Chapter['id']) {
  tryOpenLesson(id)
}

export function RegisterFlow(nextStep: string) {
  AppStatus.setModal(nextStep as any)
}

export function Contribute(prompt?: Prompt, lesson?: Chapter['id']) {
  onContributeStart({ prompt, lesson })
}
